module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "epa-petroleum--cover.c32979a9.jpg";